import { Component } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { BackToTopComponent } from './components/back-to-top/back-to-top.component'
import { PreloaderComponent } from './components/preloader/preloader.component'
import { TitleService } from '@core/services/title.service'
import { IntercomService } from '@core/services/intercom.service'
import { TermlyService } from './services/termly.service'

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, BackToTopComponent, PreloaderComponent],
  styles: `
    :host(app-root) {
      display: contents;
    }
  `,
  templateUrl: './app.component.html',
})
export class AppComponent {
  constructor(
    private titleService: TitleService,
    private intercomService: IntercomService,
    private _termlyService: TermlyService
  ) {}
  ngOnInit(): void {
    this.titleService.init()
    this.intercomService.initialize()
  }

  openPreferences() {
    this._termlyService.showPreferencesModal()
  }
}
